import { useCallback,useMemo, useState } from 'react';
import { ListItemField } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core/hooks';
import { EmployerStatus } from '@/modules/employer/employer.constants';
import { Employer } from '@/modules/employer/employer.types';

const DEFAULT_DEACTIVATION_ITEM = { id: '', title: '', isLocked: false };
const REQUIRED_PERMISSIONS = [{ permission: Permissions.ORG_LOCK }];

export default (list: Employer[]) => {
  const [lockUnlockItem, setLockUnlockItem] = useState(DEFAULT_DEACTIVATION_ITEM);
  const hasAccess = useHasAccess(REQUIRED_PERMISSIONS);
  const lockOption = useMemo(() => {
    if (!hasAccess) {
      return null;
    }
    return {
      name: 'Lock',
      onClick: (id: string, title?: string) => setLockUnlockItem({ id, title: title || '', isLocked: false }),
      isAvailable: (fields: ListItemField[], id: string) => {
        const item = list.find((field) => field.id === id);

        if (item?.status?.toUpperCase() === EmployerStatus.ExpressSetup || item?.status?.toUpperCase() === EmployerStatus.Abandoned) {
          return false;
        }
        if (item?.status?.toUpperCase() === EmployerStatus.Terminated) {
          return false;
        }

        return !item?.isLocked;
      },
    };
  }, [hasAccess, list]);

  const unlockOption = useMemo(() => {
    if (!hasAccess) {
      return null;
    }
    return {
      name: 'Unlock',
      onClick: (id: string, title?: string) => setLockUnlockItem({ id, title: title || '', isLocked: true }),
      isAvailable: (fields: ListItemField[], id: string) => {
        const item = list.find((field) => field.id === id);

        if (item?.status?.toUpperCase() === EmployerStatus.ExpressSetup || item?.status?.toUpperCase() === EmployerStatus.Abandoned) {
          return false;
        }

        if (item?.status?.toUpperCase() === EmployerStatus.Terminated) {
          return false;
        }

        return !!item?.isLocked;
      },
    };
  }, [hasAccess, list]);

  const handleResetLockUnlock = useCallback(() => {
    setLockUnlockItem(DEFAULT_DEACTIVATION_ITEM);
  }, []);

  return {
    lockOption,
    unlockOption,
    lockUnlockItem,
    handleResetLockUnlock,
  };
};
